import planificationEscl from '../../../locales/es-CL/planification.json';
import planificationEsmx from '../../../locales/es-MX/planification.json';
import planificationEsco from '../../../locales/es-CO/planification.json';
import planificationEnus from '../../../locales/en-US/planification.json';
import Container from 'typedi';
import LogService from '../../../services/LogService';
import ProgressBar from '../../../components/ProgressBar.vue';
import showAlert from '../../../alert/alertHandler';
import showConfirmation from '../../../confirmation/confirmationHandler';
import axios from 'axios';
import moment from 'moment';
import draggable from 'vuedraggable';

import GoogleMapsApiLoader from 'google-maps-api-loader';
import RouteDetailMap from '../../../components/RouteDetailMap.vue';
export default {
  name: 'RouteProcess',
  components: {
    draggable,
    ProgressBar,
    RouteDetailMap,
    GoogleMapsApiLoader,
  },
  props: {
    planificationId: {
      type: String,
      default: null,
    },
    planificationState: {
      type: String,
      default: null,
    },
    planificationOngoing: {
      type: Boolean,
      default: false,
    },
  },
  i18n: {
    messages: {
      'es-CL': {
        planification: planificationEscl,
      },
      'es-MX': {
        planification: planificationEsmx,
      },
      'es-CO': {
        planification: planificationEsco,
      },
      'en-US': {
        planification: planificationEnus,
      },
    },
  },
  data() {
    return {
      actualStep: 'routes',
      drag: false,
      optionSpots: [],
      logService: null,
      dataAccess: null,
      filter: null,
      planIsOngoing: false,
      namePlanification: null,
      routeSelected: null,
      vehicleSelected: null,
      driverSelected: null,
      isMainPageBussy: false,
      firstAdviceOperation: true,
      selectedAllOperationsToMove: false,
      isPlanificationReady: false,
      openUnreacheable: false,
      lockMoveButton: false,
      unreachableOperations: [],
      unreachableOperationsNoRoute: [],
      routeNames: [],
      optimizationResultParsed: [],
      optimizationResultEditMode: [],
      checkedOperationsToMove: [],
      checkedOperationsOptimized: [],
      operationsReasigned: [],
      optimizationBody: {},
      optimizationInput: {},
      optimizationOutput: {},
      optimizationResult: {},
      actualClicked: -1,
      usedEditModal: false,
      sortingOperations: false,
      requireSortOperations: false,
      //Data que proviene de otros procesos y se setearan en estas variables
      tags: [],
      operations: [],
      spotsTemporalData: [],
      depotOrigin: null,
      depotDestination: null,
      checkedVehicles: [],
      checkedDrivers: [],
      checkedGeoFences: [],
      geoFence: [],
      vehicles: [],
      drivers: [],
      useGeoFence: false,
      useAllFleet: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    const allowedRoutes = [
      'OperationProcess',
      'OperationProcessNotOngoing',
      'DateAndDepotProcess',
      'DateAndDepotProcessNotOngoing',
      'ResourceProcess',
      'ResourceProcessNotOngoing',
      'RouteProcess',
      'RouteProcessNotOngoing',
      'PlanificationBuilder',
      'PlanificationBuilderNotOngoing',
    ];
    if (!allowedRoutes.includes(to.name)) {
      this.$store.commit('setMetaData', null); // Limpia los datos si no es una ruta permitida
      this.$store.commit('setInputOptimization', null);
      this.$store.commit('setOututOptimization', null);
    }
    next(); // Permite la navegación
  },
  created() {
    this.dataAccess = this.$store.getters.dataAccess;
    this.logService = Container.get(LogService);
    if (this.jsonData && this.jsonData.gapi) {
      this.gapi = this.jsonData.gapi;
    } else {
      GoogleMapsApiLoader({
        libraries: ['places', 'marker'],
        apiKey: this.$store.getters.apiKey,
      }).then((google) => {
        this.gapi = google;
      });
    }
    this.preparedData();
  },
  methods: {
    async preparedData() {
      this.isMainPageBussy = true;
      this.actualClicked = -1;
      await this.prepareDataFromOtherStage();
      const optimizationBody = this.$store.getters.optimizationBody
        ? JSON.stringify(this.$store.getters.optimizationBody)
        : '{}';
      const inputOptimization = this.$store.getters.inputOptimization
        ? JSON.stringify(this.$store.getters.inputOptimization)
        : '{}';
      const outputOptimization = this.$store.getters.outputOptimization
        ? JSON.stringify(this.$store.getters.outputOptimization)
        : '{}';
      const optimizationResult = this.$store.getters.optimizationResult
        ? JSON.stringify(this.$store.getters.optimizationResult)
        : '{}';
      //El body que se envia al optimizador
      this.optimizationBody = JSON.parse(optimizationBody);
      //EL input guardado en la BD, puede tener diferencias al body si es que hubieron cambios
      this.optimizationInput = JSON.parse(inputOptimization);
      //Resultado de la optimizacion en BD, puede tener cambios en los recursos y operaciones nuevas en unrecheable si es que se hizxo alguna modificacion
      this.optimizationOutput = JSON.parse(outputOptimization);
      //Resultado de la optimización a partir del bdoy dado al optimzador, este es el que se usara para poblar la data de la vista
      this.optimizationResult = JSON.parse(optimizationResult);
      if (this.planificationId) {
        this.planIsOngoing =
          this.planificationState && (this.planificationState === 'STARTED' || this.planificationState === 'ONGOING')
            ? true
            : false;
        this.namePlanification =
          this.optimizationInput && 'name' in this.optimizationInput ? this.optimizationInput.name : this.form.name;
      }
      this.unreachableOperations = this.optimizationResult.unreachableOperations;

      // TRAN-1975: marcar operaciones sin ruta
      this.updateUnreachableOperationsNoRoute();
      await this.processRouteResult(this.optimizationResult.routes);
      //Esto hace que le mensaje de advertencia empiece cerrado
      this.scrollToTop();
      if (this.unreachableOperations.length > 0) {
        this.showModal('advice-operation-not-assigned');
      }
      //Si mi resultado posee rutas entonces la vista mostrara la primera ruta desplegada
      if (this.optimizationResultParsed.length > 0) {
        let route = this.optimizationResultParsed[0];
        await this.waitForElm('#planificationRoute0');
        this.toogleCollapse(route, 'planificationRoute' + 0, 0);
        this.renderRouteOnMap(0);
      }
      this.isMainPageBussy = false;
    },
    async prepareDataFromOtherStage() {
      this.$set(this, 'operations', this.jsonData.operations ?? []);

      this.$set(this, 'spotsTemporalData', this.jsonData.spotsTemporalData ?? []);
      this.tags = this.jsonData.tags ?? [];
      this.depotOrigin = this.jsonData.depotOrigin ?? this.depotOrigin;
      this.depotDestination = this.jsonData.depotDestination ?? this.depotDestination;
      this.$set(this, 'checkedVehicles', this.jsonData.checkedVehicles || []);
      this.$set(this, 'checkedDrivers', this.jsonData.checkedDrivers || []);
      this.$set(this, 'checkedGeoFences', this.jsonData.checkedGeoFences || []);
      this.$set(this, 'vehicles', this.jsonData.vehicles || []);
      this.$set(this, 'drivers', this.jsonData.drivers || []);
      this.$set(this, 'geofence', this.jsonData.geofence || []);

      this.useGeoFence = this.jsonData.useGeoFence !== undefined ? this.jsonData.useGeoFence : this.useGeoFence;
      this.useAllFleet = this.jsonData.useAllFleet !== undefined ? this.jsonData.useAllFleet : this.useAllFleet;
    },
    async processRouteResult(routes) {
      try {
        //Reseteo los nombres
        this.routeNames = [];
        console.log('Rutaas ', routes);
        this.optimizationResultParsed = [];
        routes.forEach((route, index) => {
          this.logService.sendInfo({
            component: 'planificationBUilder',
            message: `processRouteResult convirtiendo la ruta ${index}`,
            data: route,
          });
          let routeTemp = {};
          routeTemp.id = route.id;
          routeTemp.index = index + 1;
          routeTemp.firstDragg = route.resources[0].firstDragg != undefined ? route.resources[0].firstDragg : true;
          routeTemp.isClicked = false;
          routeTemp.name = `Route ${index + 1}`;
          routeTemp.initHour = this.getInitRoute(route);
          routeTemp.lastHour = new Date(this.getDurationRoute(route)).toISOString().substring(11, 16);
          routeTemp.totalVehicles = route.resources.length;
          routeTemp.totalOperations = this.getTotalOperations(route);
          //console.log('probando ', route, routeTemp.totalOperations);
          routeTemp.vehicle = route.resources[0].extraInfo.vehicle; //Por ahora esto es asi, luego puede ser un arreglo (?)
          routeTemp.driver = route.resources[0].extraInfo.driver;
          routeTemp.totalDistance = (route.resources[0].totalDistance / 1000).toFixed(2);
          routeTemp.totalDistanceFull = route.resources[0].totalDistance;
          routeTemp.totalTimeFull = route.resources[0].totalTime;
          routeTemp.extraInfo = route.resources[0].extraInfo;
          routeTemp.checkAllOperations = false;
          let operations = [];

          if (route.resources[0].operations.length > 0) {
            route.resources[0].operations.forEach((operation, index) => {
              if (operation.task === 'DELIVERY' || operation.task === 'COLLECTION') {
                let body = {
                  uuid: operation.uuid,
                  name: operation.name != undefined ? operation.name : '--',
                  initHour: this.formatDateHHss(operation.scheduled),
                  address: operation.spot.extraInfo.address,
                  spot: operation.spot,
                  idSolver: operation.extraInfo.idSolver,
                  spotTimeWindow: operation.spotTimeWindow != null ? operation.spotTimeWindow : null,
                  operationTime: operation.operationTime,
                  extraInfo: operation.extraInfo,
                  operationState: operation.extraInfo.operationState,
                  money: operation.money,
                  weight: operation.weight,
                  volume: operation.volume,
                  task: operation.task,
                };
                if (operation.tags) {
                  body = {
                    ...body,
                    tags: operation.tags,
                  };
                }
                operations.push(body);
              }
              if (operation.task === 'START') {
                routeTemp.initSpot = operation.spot;
                routeTemp.initScheduled = operation.scheduled;
              } else if (operation.task === 'END') {
                let lastOperation = route.resources[0].operations[index - 1];
                if (
                  lastOperation.task === 'DRIVING' ||
                  lastOperation.task === 'UNLOAD' ||
                  (lastOperation.spot.lat != operation.spot.lat && lastOperation.spot.lon !== operation.spot.lon)
                ) {
                  routeTemp.lastSpot = operation.spot;
                }
              }
            });
          }
          routeTemp.operations = operations;
          this.routeNames.push({
            index: index + 1,
            name: routeTemp.name,
            driver: routeTemp.driver,
            vehicle: routeTemp.vehicle,
          });
          this.optimizationResultParsed.push(routeTemp);
        });
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `processRouteResult fallo el convertir el resultado en el esperado para la vista ${e.message}`,
        });
        this.isOptimizationBussy = false;
        console.log(e);
      }
    },
    openAdviceModal() {
      this.firstAdviceOperation = false;
      this.showModal('advice-operation-not-assigned');
    },
    getSpotAddress(spotName) {
      const spotTemporal = this.optimizationBody.spots.find((s) => parseInt(s.name) === parseInt(spotName));
      if (spotTemporal) {
        return spotTemporal.extraInfo.address;
      }
      return '';
    },
    //Metodo que cuenta las tareas a realizar de una ruta.
    getTotalOperations(route) {
      let totalOperations = 0;
      route.resources.forEach((resource) => {
        resource.operations.forEach((operation) => {
          //la logica dependiendo si es delivery o collection cambia, por lo que se deja este "if" como generico para contabilizar operaciones
          if (operation.task == 'LOAD' || operation.task == 'UNLOAD') {
            totalOperations += operation.deliveries != undefined ? operation.deliveries.length : 0;
            totalOperations += operation.collections != undefined ? operation.collections.length : 0;
          }
        });
      });
      return totalOperations;
    },
    //Metodo que obtiene la duracion de la ruta.
    getDurationRoute(route) {
      let maxLastDate = 0;
      let minInitDate = 9999999999999;
      route.resources.forEach((resource) => {
        resource.operations.forEach((operation) => {
          if (operation.task == 'END') {
            if (operation.scheduled > maxLastDate) {
              maxLastDate = operation.scheduled;
            }
          } else if (operation.task == 'START') {
            if (operation.scheduled < minInitDate) {
              minInitDate = operation.scheduled;
            }
          }
        });
      });
      return maxLastDate - minInitDate;
    },
    //Metodo que dirige a la parte superior de la pantalla, hace un scroll to top pero al elemento que esta arriba
    scrollToTop() {
      const topElement = document.getElementById('topElement');
      topElement.scrollIntoView({ behavior: 'smooth' });
    },
    async renderRouteOnMap(index) {
      if (this.actualClicked !== index) {
        this.actualClicked = index;
        let initSpotList = [];
        let lastSpotList = [];
        let acitivitySpotList = [];

        initSpotList.push({
          index: index,
          spot: this.optimizationResultParsed[index].initSpot,
        });
        lastSpotList.push({
          index: index,
          spot: this.optimizationResultParsed[index].lastSpot,
        });
        this.optimizationResultParsed[index].operations.forEach((operation, index2) => {
          acitivitySpotList.push({
            name: operation.name,
            index: index,
            subIndex: index2,
            spot: operation.spot,
            state: operation.operationState,
          });
        });
        if (this.useGeoFence) {
          const resourceInput = this.optimizationBody.resources.find(
            (resource) => resource.extraInfo.vehicle.id === this.optimizationResultParsed[index].vehicle.id,
          );
          this.usedGeofence = this.geoFence.find((geo) => resourceInput.geofences.includes(geo.id.toString()));
        } else {
          this.usedGeofence = null;
        }
        //Prepare map
        console.log('gapi ', this.gapi);
        await this.waitForElm('#map');
        await this.$refs.map.setSpotsWRouteOptimization(
          this.gapi,
          initSpotList,
          acitivitySpotList,
          lastSpotList,
          this.optimizationResultParsed.length - 1,
          this.unreachableOperations,
          this.spotsTemporalData,
          this.usedGeofence,
        );
      }
    },
    //Metodo que obtiene la fecha mas joven del inicio de actividades para definirlo como inicio de ruta.
    getInitRoute(route) {
      let minInitDate = 9999999999999;
      route.resources.forEach((resource) => {
        resource.operations.forEach((operation) => {
          if (operation.task == 'START') {
            if (operation.scheduled < minInitDate) {
              minInitDate = operation.scheduled;
            }
          }
        });
      });
      return this.formatDateHHss(minInitDate);
    },
    formatDateHHss(date) {
      return moment(date).format('hh:mm A');
    },
    /**
     * Metodo que recalcula los tiempos de las operaciones al eliminar una
     * @param {Route solver} chooseRoute
     */
    async updateOperationOptimized(evt, indexRoute) {
      this.sortingOperations = true;
      this.auxOptimizedResult = JSON.parse(JSON.stringify(this.optimizationResult));
      let parsedRoute = this.optimizationResultParsed[indexRoute];
      let operations = parsedRoute.operations;
      //Capturo la operacion, la siguiente y la anterior a la seleccionada, obtenidas del array optimizationResultParsed
      let actualOperation = operations[evt.moved.newIndex];
      let newNextOperationParsed = operations[evt.moved.newIndex + 1];
      let newPreviusOperationParsed;
      if (!newNextOperationParsed) {
        newPreviusOperationParsed = operations[evt.moved.newIndex - 1];
      }

      let oldId = null;
      let routes = this.optimizationResult.routes[indexRoute].resources[0];
      routes.firstDragg = parsedRoute.firstDragg;
      //Obtencion del objeto de la operacion, y del indice en el que se encuentra
      let operationToMove = routes.operations.find((operation, index) => {
        if (operation.extraInfo && operation.extraInfo.idSolver == actualOperation.idSolver) {
          oldId = index;
          return operation;
        }
      });
      let drivingOperation = routes.operations[oldId - 1].task == 'DRIVING' ? routes.operations[oldId - 1] : null;
      //Elimina la operacion que se movio en conjunto a su operacion driving si es que posee
      if (drivingOperation) {
        routes.operations.splice(oldId - 1, 2);
      } else {
        routes.operations.splice(oldId, 1);
      }
      this.repositionOperation(
        routes,
        operationToMove,
        drivingOperation,
        newNextOperationParsed,
        newPreviusOperationParsed,
      );
      let noValidate = false;
      let massUpdate = false;
      await this.recalculateOperations(routes, indexRoute, noValidate, massUpdate);
      this.sortingOperations = false;
    },
    repositionOperation(routes, operationToMove, drivingOperation, newNextOperationParsed, newPreviusOperationParsed) {
      let idForNewOperation = null;
      let isEndOperation = false;
      routes.operations.filter((operation, index) => {
        if (
          operation.extraInfo &&
          newNextOperationParsed &&
          operation.extraInfo.idSolver == newNextOperationParsed.idSolver
        ) {
          idForNewOperation = index;
          return;
        } else if (
          operation.extraInfo &&
          newPreviusOperationParsed &&
          operation.extraInfo.idSolver == newPreviusOperationParsed.idSolver
        ) {
          if (routes.operations[index + 1].task == 'END') {
            isEndOperation = true;
          }
          idForNewOperation = index + 1;
          return;
        }
      });
      //Reinserta los valores eliminados en la nueva posicion del array
      if (drivingOperation) {
        //Si hay una
        if (isEndOperation) {
          routes.operations.splice(idForNewOperation, 0, drivingOperation, operationToMove);
        } else {
          routes.operations.splice(idForNewOperation, 0, operationToMove, drivingOperation);
        }
      } else {
        routes.operations.splice(idForNewOperation, 0, operationToMove);
      }
    },
    toogleCollapse(route, idCollapse, index) {
      this.selectedRoute = route;
      this.selectedRoute.idCollapse = idCollapse;
      this.selectedRoute.isCollapseClicked = !this.selectedRoute.isCollapseClicked;
      this.$root.$emit('bv::toggle::collapse', idCollapse);
      this.optimizationResultParsed[index] = this.selectedRoute;
    },
    toogleCollapseUnreacheable(idCollapse) {
      this.openUnreacheable = !this.openUnreacheable;
      this.$root.$emit('bv::toggle::collapse', idCollapse);
    },
    callSort(route) {
      if (route.firstDragg === true) {
        showConfirmation(
          this.$t('common.modals.warning'),
          this.$t('planification.planificationBuilder.modal.dragAdvice'),
          () => {
            route.firstDragg = false;
          },
          this.$t('common.cruds.aceptar'),
          this.$t('common.cruds.cerrar'),
        );
      }
      this.drag = true;
    },
    async waitForElm(selector) {
      return new Promise((resolve) => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    },
    // TRAN-1975: marcar con etiqueta las operaciones que no tienen ruta posible
    updateUnreachableOperationsNoRoute() {
      this.unreachableOperationsNoRoute = [];
      if (!this.unreachableOperations || this.unreachableOperations.length == 0) return;
      this.unreachableOperationsNoRoute = this.findOperationsWithNoRoute(this.unreachableOperations);
    },
    findOperationsWithNoRoute(operationsArray) {
      try {
        // si desde el depot de origen no hay camino hasta alguna operacion (distancia o tiempo inf) es marcada
        const operationsWithNoRoute = [];
        const maxValue = 90000000000000000.0;
        if (!operationsArray || operationsArray.length === 0) return [];
        operationsArray.forEach((op) => {
          const depotIdx = this.optimizationBody.depots[0].name;
          const spotIdx = this.isPlainObject(op.spot) ? op.spot.name : op.spot;
          //Esta validación es para los casos en que se edita una planin en curso
          //Este caso se da cuando añado nuevas operaciones, ya que la distance matrix no tiene datos desde la bodega a los nuevos destinos
          const distanceMatrixDepot = this.optimizationResult.distanceMatrix.spots[depotIdx][spotIdx]
            ? this.optimizationResult.distanceMatrix.spots[depotIdx][spotIdx]
            : this.optimizationResult.distanceMatrix.spots[spotIdx][depotIdx];
          if (distanceMatrixDepot[0] > maxValue || distanceMatrixDepot[1] > maxValue) {
            operationsWithNoRoute.push(op.uuid);
          }
        });
        //console.log("operations with no route", operationsWithNoRoute)
        return operationsWithNoRoute;
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `findOperationsWithNoRoute fallo en añadir las operaciones sin distance matrix ${e.message}`,
        });
        console.log(e);
        return [];
      }
    },
    backResources() {
      if (this.planificationId) {
        this.$router.push({
          name: 'ResourceProcess',
          params: {
            planificationId: this.planificationId,
            planificationState: this.planificationState,
            planificationOngoing: this.planIsOngoing,
          },
        });
      } else {
        this.$router.push({
          name: 'ResourceProcessNotOngoing',
          params: {
            planificationId: this.planificationId,
            planificationState: this.planificationState,
            planificationOngoing: this.planIsOngoing,
          },
        });
      }
    },
    onSelectDriver() {
      if (this.driverSelected) {
        //Se actualiza este valor para manejarlo en el multiselect
        this.routeSelected.driver = this.driverSelected;
        //Actualizo el listado
        let updateDriver = this.routeNames.find((route) => route.name == this.routeSelected.name);
        updateDriver.driver = this.driverSelected;
      }
    },
    onSelectVehicle() {
      if (this.vehicleSelected) {
        this.routeSelected.vehicle = this.vehicleSelected;
        let updateVehicle = this.routeNames.find((route) => route.name == this.routeSelected.name);
        updateVehicle.vehicle = this.vehicleSelected;
      }
    },
    confirmDelete(operation, index) {
      if (this.optimizationResultParsed[index].operations.length <= 1) {
        showAlert(
          this.$t('planification.planificationBuilder.modal.advice'),
          this.$t('planification.planificationBuilder.modal.noOperation'),
          this.$t('common.cruds.aceptar'),
        );
        return;
      }
      showConfirmation(
        this.$t('planification.planificationBuilder.modal.confirmRemove'),
        this.$t('planification.planificationBuilder.modal.bodyRemove', { name: operation.name }),
        async () => {
          await this.deleteOperationOptimized(operation, index);
        },
        this.$t('planification.planificationBuilder.editModal.remove'),
        this.$t('common.botones.cancelar'),
      );
    },
    async deleteOperationOptimized(operation, index) {
      this.sortingOperations = true;
      this.auxOptimizedResult = JSON.parse(JSON.stringify(this.optimizationResult));
      let chooseRoute = this.optimizationResult.routes[index].resources[0];
      //Variables para manejar los datos movidos
      let loadOperation = null;
      let previusOperationId = null;
      let actualOperationId = null;
      let depotStart = null;
      for (let i = 0; i < chooseRoute.operations.length; i++) {
        let actualOperation = chooseRoute.operations[i];
        if (actualOperation.task == 'LOAD') {
          loadOperation = actualOperation;
        }
        if (actualOperation.task == 'START') {
          depotStart = actualOperation;
        } else if (actualOperation.extraInfo && actualOperation.extraInfo.idSolver == operation.idSolver) {
          let previusOperation = chooseRoute.operations[i - 1];
          let nextOperation = chooseRoute.operations[i + 1];
          //Caso si la operacion esta entre dos ubicaciones diferentes
          if (
            (previusOperation.task == 'DRIVING' && nextOperation.task == 'DRIVING') ||
            (previusOperation.task == 'DRIVING' && nextOperation.task == 'END')
          ) {
            previusOperationId = i - 1;
            actualOperationId = i;
          } else {
            actualOperationId = i;
          }
        }
      }
      await this.spliceDeletedOperation(actualOperationId, chooseRoute, previusOperationId, loadOperation, depotStart);

      let noValidate = false;
      let massUpdate = false;
      await this.recalculateOperations(chooseRoute, index, noValidate, massUpdate);
      this.sortingOperations = false;
    },
    removeOperationsEditMode() {
      if (this.checkedOperationsOptimized.length > 0) {
        showConfirmation(
          this.$t('common.modals.confirmacionTitulo'),
          'Esta a punto de eliminar las operaciones seleccionadas, esta seguro de realizar esta acción?',
          () => {
            this.removeFromListEditMode();
          },
          this.$t('common.cruds.aceptar'),
          this.$t('common.cruds.cerrar'),
        );
      }
    },
    removeFromListEditMode() {
      //Elimino del listado las operaciones seleccionadas
      this.optimizationResultEditMode.forEach((route) => {
        route.operations = route.operations.filter((operation) => {
          return !this.checkedOperationsOptimized.some(
            (deleteOperation) => deleteOperation.extraInfo.idSolver === operation.extraInfo.idSolver,
          );
        });
      });
      this.checkedOperationsOptimized = [];
    },
    isPlainObject(obj) {
      return Object.prototype.toString.call(obj) === '[object Object]';
    },
    moveOperations() {
      if (this.routeSelected) {
        console.log(
          'operaciones seleccionadas ',
          this.checkedOperationsOptimized,
          this.checkedOperationsOptimized.length,
        );
        this.checkedOperationsOptimized.forEach((operation) => {
          this.operationsReasigned.push(operation);
        });
        this.removeFromListEditMode();
        for (let i = 0; i < this.optimizationResultEditMode.length; i++) {
          let checkbox = document.getElementById('selectOperations' + i);
          if (checkbox) {
            checkbox.checked = false;
          }
        }
      } else {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.validaciones.operationToMoveEmpty'),
          'error',
        );
      }
    },
    addOperationsEditMode() {
      if (this.routeSelected) {
        let route = this.optimizationResultEditMode.find((route) => route.name == this.routeSelected.name);
        console.log(route, this.routeSelected.name);
        this.checkedOperationsToMove.forEach((op) => {
          route.operations.push(op);
        });
        //Del listado de operaciones  en destino de actividades, verifico cuales estan checkeadas para sacarlas
        this.operationsReasigned = this.operationsReasigned.filter((operation) => {
          return !this.checkedOperationsToMove.some(
            (deleteOperation) => deleteOperation.extraInfo.idSolver === operation.extraInfo.idSolver,
          );
        });
        if (this.operationsReasigned.length == 0) {
          this.routeSelected = null;
        }
        this.checkedOperationsToMove = [];
        this.selectedAllOperationsToMove = false;
      } else {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.validaciones.operationToMoveEmpty'),
          'error',
        );
      }
    },
    checkOperationsToMove() {
      if (this.selectedAllOperationsToMove) {
        this.checkedOperationsToMove = this.operationsReasigned;
      } else {
        this.checkedOperationsToMove = [];
      }
    },
    reMoveOperations() {
      this.optimizationResultEditMode.map((route) => (route.checkAllOperations = false));
      this.routeSelected = null;
      this.checkedOperationsToMove = [];
      this.selectedAllOperationsToMove = false;
      //Los añado a la primera ubicación del listado que son las no asignadas
      this.operationsReasigned.forEach((op) => {
        let routeUnassigned = this.optimizationResultEditMode[0];
        if (routeUnassigned.name == 'unreachableActivity') {
          routeUnassigned.operations.push(op);
        } else {
          //Por mejora visual aca las que envio a unreachable estaran por defecto desplegadas si es que no existen
          this.optimizationResultEditMode.splice(0, 0, {
            id: 0,
            isClicked: true,
            name: 'unreachableActivity',
            operations: [op],
          });
        }
      });
      this.operationsReasigned = [];
    },
    checkOperations(route, idx, event) {
      // listado de operaciones que no tienen ruta
      let noRouteOperations = [];
      if (route.name === 'unreachableActivity') {
        noRouteOperations = this.findOperationsWithNoRoute(route.operations);
      }

      route.checkAllOperations = !route.checkAllOperations;
      const checkAll = route.checkAllOperations;

      let opWithNoRoute = 0;
      route.operations.forEach((operation) => {
        let index = this.checkedOperationsOptimized.findIndex(
          (op) => op.extraInfo.idSolver == operation.extraInfo.idSolver,
        );
        if (index >= 0 && !checkAll) {
          this.checkedOperationsOptimized.splice(index, 1);
        } else if (checkAll && index < 0) {
          // si la operacion no tiene ruta, no la puede seleccionar masivo
          if (this.hasOperationRoute(noRouteOperations, operation.uuid)) {
            this.checkedOperationsOptimized.push(operation);
          } else {
            opWithNoRoute++;
          }
        }
      });

      // previene marcar la casilla de todos si es que todas las ops no tienen ruta
      if (opWithNoRoute > 0 && route.operations.length === opWithNoRoute) {
        route.checkAllOperations = !route.checkAllOperations;
        event.target.checked = false;
      }

      this.checkNoRouteOperationsChecked();
    },
    checkOperation(route, operation) {
      route.name;
      operation.uuid;
      this.checkNoRouteOperationsChecked();
    },
    checkNoRouteOperationsChecked() {
      let noRouteOperations = this.findOperationsWithNoRoute(this.checkedOperationsOptimized);
      let isCheckedNoRouteOperation = false;
      this.checkedOperationsOptimized.forEach((op) => {
        if (!this.hasOperationRoute(noRouteOperations, op.uuid)) {
          isCheckedNoRouteOperation = true;
        }
      });
      this.lockMoveButton = isCheckedNoRouteOperation;
    },
    openOperations(route) {
      route.isClicked = !route.isClicked;
    },
    /**
     * Metodo que construye el json de la respuesta del optimizador, si la ruta posee operaciones entonces genera una repuesta de optimizador
     * y luego procede a recalcular los tiempos con el metodo de recalculate
     */
    async saveEdit() {
      this.usedEditModal = true; //Esta variable se usa para mostrar la opcion de reoptimización
      this.optimizationBody.tags = [];
      this.optimizationResultEditMode.forEach(async (route) => {
        if (route.name == 'unreachableActivity') {
          let body = [];
          route.operations.forEach((op) => {
            let bodyUnreachable = {
              uuid: op.uuid,
              name: op.name,
              spot: op.spot.name ? parseInt(op.spot.name) : parseInt(op.spot), //Significa que si no tiene el objeto spot, es que en el atriuto spot ya posee el name
              volume: op.volume ? op.volume : 0,
              weight: op.weight ? op.weight : 0,
              money: op.money ? op.money : 0,
              extraInfo: op.extraInfo,
              task: op.task ? op.task : 'DELIVERY',
              spotServiceTime: op.spotServiceTime ? op.spotServiceTime : op.operationTime,
              depot: this.optimizationResultParsed[0].initSpot.name,
            };
            if (op.spotTimeWindow != undefined && op.spotTimeWindow.startTime) {
              bodyUnreachable = {
                ...bodyUnreachable,
                spotTimeWindow: op.spotTimeWindow,
              };
            }
            if (op.tags) {
              bodyUnreachable = {
                ...bodyUnreachable,
                tags: op.tags,
              };
              this.optimizationBody.tags = this.optimizationBody.tags.concat(op.tags);
            }
            body.push(bodyUnreachable);
          });
          //Al ser esta el modal de edicion solamente existe una ruta cuyo nombre es actividades sin asignar
          //Por lo tanto el body resultante es el total de unreachableOperations
          this.optimizationResult.unreachableOperations = body;
        } else {
          let body = [];
          let routeFromSolver = this.optimizationResultParsed.find((rSolver) => rSolver.name == route.name);
          //Construyo el body del solver para rutas optimizadas
          this.makeBodySolver(body, route, routeFromSolver);
          let routeToChange = this.optimizationResult.routes.find((r) => r.id == route.id);
          let indexToDelete = this.optimizationResult.routes.findIndex((r) => r.id == route.id);
          //Si existe la ruta en la respuesta del optimizador entonces la actualizara
          if (routeToChange) {
            //La ruta que voy a actualizar debe tener al menos una operacion, sino se elimina
            if (route.operations.length > 0) {
              routeToChange.resources[0].operations = body;
              let noValidate = true;
              let massUpdate = true;
              //Busco el recurso en el listado routeNames para actualizar la ruta del optimizador
              let resourceToUpdate = this.routeNames.find((r) => r.name == route.name);
              //Actualizo el recurso de la ruta
              this.changeResourcesSolver(routeToChange, resourceToUpdate);
              await this.recalculateOperations(routeToChange.resources[0], null, noValidate, massUpdate);
            } else {
              //Elimino la ruta si es que esta con actividades vacias
              this.optimizationResult.routes.splice(indexToDelete, 1);
            }
          }
          console.log('Respuesta solver ', route.name, route.operations.length, routeToChange);
        }
      });
      //Como actualice los recursos debo cambiar el body del input de vehicles, esto incluye los drivers
      await this.makeBodyVehicles();
      this.updateTagsVehicles();
      //Esto es un massUpdate por lo tanto se refresca fuera del for para refrescar todas las rutas
      this.unreachableOperations = this.optimizationResult.unreachableOperations;
      // TRAN-1975: marcar operaciones sin ruta
      this.updateUnreachableOperationsNoRoute();
      //Resetea el clicked para poder clickear el mpaa y recargar
      this.actualClicked = -1;
      //Valida si hay alguna ruta seleccionada para cerrar su collapse
      if (this.selectedRoute && this.selectedRoute.isCollapseClicked) {
        this.selectedRoute.isCollapseClicked = !this.selectedRoute.isCollapseClicked;
        this.$root.$emit('bv::toggle::collapse', this.selectedRoute.idCollapse);
      }

      this.optimizationBody.tags = [...new Set(this.optimizationBody.tags)];
      await this.processRouteResult(this.optimizationResult.routes);
      this.optimizationResult.statistics.unreachableOperations = this.optimizationResult.unreachableOperations.length;
      this.optimizationResult.statistics.totalOperations = this.optimizationBody.operations.length;
      this.optimizationResult.statistics.reachableOperations =
        this.optimizationBody.operations.length - this.optimizationResult.unreachableOperations.length;
      this.closeModal('edit-optimization-modal');
    },
    changeResourcesSolver(routeToChange, resourceToUpdate) {
      //Se actualiza el recurso del optimizador
      routeToChange.resources[0].name = resourceToUpdate.vehicle.plate.toString();
      routeToChange.resources[0].extraInfo = {
        driver: {
          id: resourceToUpdate.driver.id,
          driverName: resourceToUpdate.driver.driverName,
        },
        vehicle: {
          id: resourceToUpdate.vehicle.id,
          plate: resourceToUpdate.vehicle.plate,
          idVehicleOperaciones: resourceToUpdate.vehicle.idVehicleOperaciones
            ? resourceToUpdate.vehicle.idVehicleOperaciones
            : resourceToUpdate.vehicle.id_vehicle_operaciones,
        },
      };
    },
    makeBodySolver(body, route, routeFromSolver) {
      body.push({
        spot: routeFromSolver ? routeFromSolver.initSpot : null,
        scheduled: routeFromSolver.initScheduled,
        task: 'START',
      });
      body.push({
        spot: routeFromSolver ? routeFromSolver.initSpot : null,
        scheduled: routeFromSolver.initScheduled,
        operationTime: 0,
        deliveries: route ? route.operations.map((operation) => operation.uuid) : [],
        task: 'LOAD',
      });
      //Es para añadir un task de UNLOAD en el body del optimizador
      let existCollection = false;
      route.operations.forEach((op) => {
        if (op.spot && !op.spot.name) {
          op.spot = this.optimizationBody.spots.find((spot) => spot.name == op.spot);
        }
        body.push({
          scheduled: routeFromSolver.initScheduled,
          spot: op.spot,
          task: 'DRIVING',
        });
        if (op.task === 'COLLECTION') {
          existCollection = true;
        }
        let bodyOp = {
          uuid: op.uuid,
          name: op.name,
          spot: op.spot,
          operationTime: op.spotServiceTime ? op.spotServiceTime : op.operationTime,
          scheduled: routeFromSolver.initScheduled,
          volume: op.volume ? op.volume : 0,
          weight: op.weight ? op.weight : 0,
          money: op.money ? op.money : 0,
          extraInfo: op.extraInfo,
          task: op.task ? op.task : 'DELIVERY',
        };
        if (op.spotTimeWindow != undefined && op.spotTimeWindow.startTime) {
          bodyOp = {
            ...bodyOp,
            spotTimeWindow: op.spotTimeWindow,
          };
        }
        if (op.tags != undefined && op.tags) {
          bodyOp = {
            ...bodyOp,
            tags: op.tags,
          };
          this.optimizationBody.tags = this.optimizationBody.tags.concat(op.tags);
        }
        body.push(bodyOp);
      });
      //Si el json de la respuesta del optimizador parseado, posee un lastOperation, entonces le añade su operacion driving, y usa el spot de bodega final
      if (routeFromSolver.lastSpot) {
        body.push({
          scheduled: routeFromSolver.initScheduled,
          spot: route.lastSpot,
          task: 'DRIVING',
        });
        if (existCollection) {
          //ESTO SE AÑADE SI ES QUE HAY OPERACIONES DE TIPO COLLECTION
          body.push({
            scheduled: routeFromSolver.initScheduled,
            operationTime: 0,
            spot: routeFromSolver ? routeFromSolver.lastSpot : null,
            task: 'UNLOAD',
          });
        }
        body.push({
          scheduled: routeFromSolver.initScheduled,
          spot: routeFromSolver ? routeFromSolver.lastSpot : null,
          task: 'END',
        });
      } else {
        //De lo contrario la operacion final termina con la ultima operación realizada por la ruta
        body.push({
          scheduled: routeFromSolver.initScheduled,
          spot: route.operations[-1] ? route.operations[-1].spot : null,
          task: 'END',
        });
      }
    },
    async makeBodyVehicles() {
      let resources = [];
      let listOfTypes = [];
      //Obtengo el listado de vehículos seleccionados (checkedVehicles solo contiene patentes)
      let completeInfoVehicle = this.vehicles.filter((vehicle) => this.checkedVehicles.includes(vehicle.id));

      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `Por construir makeBodyVehicles`,
        data: this.checkedVehicles,
      });
      for (const vehicle of completeInfoVehicle) {
        try {
          if (!listOfTypes.some((type) => type.id === vehicle.vehicleTypeExtra.id)) {
            //Input para el optimizador sobre los tipos de vehículos y sus caracteristicas
            listOfTypes.push({
              id: vehicle.vehicleTypeExtra.id,
              name: vehicle.vehicleTypeExtra.name,
              maxWeight:
                vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxWeigth > 0
                  ? vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxWeigth
                  : 0,
              maxMoney:
                vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxMoney > 0
                  ? vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxMoney
                  : 0,
              maxVolume:
                vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxVolume > 0
                  ? vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxVolume
                  : 0,
              maxKms:
                vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxKms > 0
                  ? vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxKms
                  : 0,
              maxVisits:
                vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxVisits > 0
                  ? vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxVisits
                  : 0,
              maxTime:
                vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxTime > 0
                  ? vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxTime
                  : 0,
              maxTimeDriving:
                vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxTimeDriving > 0
                  ? vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxTimeDriving
                  : 0,
              maxContinuosTimeDriving:
                vehicle.vehicleTypeExtra && vehicle.vehicleTypeExtra.maxContinuousTimeDriving > 0
                  ? vehicle.vehicleTypeExtra.maxContinuousTimeDriving
                  : 0,
            });
          }
        } catch (e) {
          this.logService.sendError({
            component: 'planificationBUilder',
            message: `Fallo el proceso de construir el body de vehicleTypeExtra ${e.message}`,
            data: vehicle,
          });
          throw e;
        }
        try {
          //Si el vehículo no posee algun tag asignado, busca en la bd a ver si posee alguno
          //if (!vehicle.tags) vehicle.tags = await this.getTagIdVehicle(vehicle.id);
          //Este es el body utilizado como resources para el input del optimizador
          let body = {
            name: vehicle.plate,
            type: vehicle.vehicleTypeExtra.name,
            depotStart: this.depotOrigin ? this.depotOrigin.id : null,
            extraInfo: {
              driver: {
                id: vehicle.driver.id,
                driverName: vehicle.driver.driverName,
              },
              vehicle: {
                id: vehicle.id,
                plate: vehicle.plate,
                idVehicleOperaciones: vehicle.id_vehicle_operaciones ? vehicle.id_vehicle_operaciones : null,
              },
            },
          };
          if (this.depotDestination) {
            body = {
              ...body,
              depotEnd: this.depotDestination ? this.depotDestination.id : null,
            };
          }
          if (this.useGeoFence) {
            body = {
              ...body,
              geofences: vehicle.selectedGeoFence ? [vehicle.selectedGeoFence.id.toString()] : [],
            };
          }
          //todo preparar estos arrays a que sean multiples
          if (vehicle.tags) {
            const listIdTags = vehicle.tags.map((tag) => tag.id.toString());
            body = {
              ...body,
              tags: listIdTags ? listIdTags : [],
            };
            this.optimizationBody.tags = [...this.optimizationBody.tags, ...listIdTags];
          }
          resources.push(body);
        } catch (e) {
          this.logService.sendError({
            component: 'planificationBUilder',
            message: `Fallo el proceso de construir el body de vehículos ${e.message}`,
            data: vehicle,
          });
          throw e;
        }
      }
      this.optimizationBody.resourceTypes = listOfTypes;
      this.optimizationBody.resources = resources;
    },
    updateTagsVehicles() {
      for (const route of this.optimizationResult.routes) {
        let vehicleId = route.resources[0].extraInfo.vehicle.id;
        let resource = this.optimizationBody.resources.find((resource) => resource.extraInfo.vehicle.id == vehicleId);
        if (resource && resource.tags) {
          route.resources[0].tags = resource.tags;
        }
      }
    },
    async validateSaveMode() {
      if (this.operationsReasigned.length > 0) {
        showConfirmation(
          this.$t('common.modals.confirmacionTitulo'),
          this.$t('planification.planificationBuilder.validaciones.operationInDestiny'),
          async () => {
            this.reMoveOperations();
            if (this.checkRoutesEmpty() && this.changeResources()) {
              await this.saveEdit();
            }
          },
          this.$t('common.cruds.aceptar'),
          this.$t('common.cruds.cerrar'),
        );
      } else {
        if (this.checkRoutesEmpty() && this.changeResources()) {
          await this.saveEdit();
        }
      }
    },
    checkRoutesEmpty() {
      let totalRoutesNoOperations = 0;
      let haveNoAssigned = false;
      this.optimizationResultEditMode.forEach((route) => {
        if (route.name != 'unreachableActivity') {
          if (route.operations.length == 0) {
            totalRoutesNoOperations += 1;
          }
        } else {
          haveNoAssigned = true;
        }
      });
      //Se resta uno porque al tener las actividades sin asignar esta no cuenta para validar que las rutas esten vacias
      if (haveNoAssigned) {
        if (totalRoutesNoOperations == this.optimizationResultEditMode.length - 1) {
          showAlert('Error', this.$t('planification.planificationBuilder.validaciones.routesEmptyEditMode'));
          return false;
        }
      } else {
        if (totalRoutesNoOperations == this.optimizationResultEditMode.length) {
          showAlert('Error', this.$t('planification.planificationBuilder.validaciones.routesEmptyEditMode'));
          return false;
        }
      }
      return true;
    },
    //Reprocesa los datos de la vista con los cambios realizados
    async reprocesView(indexRoute) {
      this.unreachableOperations = this.optimizationResult.unreachableOperations;
      // TRAN-1975: marcar operaciones sin ruta
      this.updateUnreachableOperationsNoRoute();
      await this.processRouteResult(this.optimizationResult.routes);
      this.actualClicked = -1;
      if (indexRoute >= 0) {
        await this.renderRouteOnMap(indexRoute);
      }
    },
    changeResources() {
      //Como recorrere de vuelta los recursos de las rutas voy a vaciar los vehículos checkeados
      this.checkedVehicles = [];
      this.optimizationResultEditMode.forEach((route) => {
        if (route.name != 'unreachableActivity') {
          //Solamente dejare los recursos si la rutas que poseo tienen operaciones
          if (route.operations.length > 0) {
            let resourceToUpdate = this.routeNames.find((r) => r.name == route.name);
            //Realiza los update añadiendo los recursos que encuentra en el listado de vehículos checkeados
            this.checkedVehicles.push(resourceToUpdate.vehicle.id);
            //Es necesario actualizar el conductor del vehículo
            let updateDriverVehicle = this.vehicles.find((veh) => veh.id == resourceToUpdate.vehicle.id);
            let fullInfoDriver = this.drivers.find((driv) => driv.id == resourceToUpdate.driver.id);
            updateDriverVehicle.driver = fullInfoDriver;
          }
        }
      });
      return this.validateCheckVehicles() && this.validateDriversSelected();
    },
    async validateCheckVehicles() {
      if (this.checkedVehicles.length > 0) {
        return true;
      }
      showAlert(
        this.$t('common.modals.errorTitulo'),
        this.$t('planification.planificationBuilder.validaciones.checkVehicles'),
        'error',
      );
      return false;
    },
    validateDriversSelected() {
      let vehiclesSelected = this.vehicles.filter((vehicle) => this.checkedVehicles.includes(vehicle.id));
      //Verificar que cada vehículo seleccionado tenga un conductor
      let totalDrivers = 0;
      let listDriver = [];
      vehiclesSelected.forEach((vehicle) => {
        if (vehicle.driver) {
          totalDrivers = totalDrivers + 1;
          listDriver.push(vehicle.driver.id);
        }
      });
      console.log(vehiclesSelected);
      listDriver = [...new Set(listDriver)];
      if (totalDrivers == vehiclesSelected.length) {
        //verifica que la cantidad de conductores unicos sea igual a los vehículos seleccionados
        if (listDriver.length == vehiclesSelected.length) {
          return true;
        } else {
          showAlert(
            this.$t('common.modals.errorTitulo'),
            this.$t('planification.planificationBuilder.validaciones.differentDrivers'),
            'error',
          );
        }
      } else {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.validaciones.notDrivers'),
          'error',
        );
      }
      return false;
      //
    },
    closeEditMode() {
      this.closeModal('edit-optimization-modal');
      this.checkedOperationsToMove = [];
      this.checkedOperationsOptimized = [];
    },
    hasOperationRoute(noRoute, operationUuid) {
      if (!noRoute || noRoute.length == 0) return true;
      return !noRoute.includes(operationUuid);
    },
    goBackWithModal() {
      this.backResources();
      this.closeModal('advice-operation-not-assigned');
    },
    async recalculateOperations(chooseRoute, indexRoute, noValidate, massUpdate) {
      this.operationsWithConflicts = [];
      //Booleano para saber si no hay conflicto con las ventanas horarias
      let isValid = true;
      chooseRoute.totalDistance = 0;
      chooseRoute.totalTime = 0;
      chooseRoute.totalWeight = 0;
      chooseRoute.totalMoney = 0;
      chooseRoute.totalVolume = 0;
      //Caso si la operacion es la primera posterior a la carga
      chooseRoute.operations.forEach(async (operation, index) => {
        if (operation.task == 'LOAD' || operation.task == 'START') {
          return;
        }
        //Recalcula todos los tiempos de operación y las distancias
        if (operation.task == 'DRIVING') {
          let previusOperation = chooseRoute.operations[index - 1];
          let nextOperation = chooseRoute.operations[index + 1];
          let distance = 0;
          let time = 1;
          //Se obtienen las dos distanceMatrix A-B  de B-A. En este punto estas dos opciones son iguales, por lo tanto ambos casos se evaluan
          let distanceMatrixAB =
            this.optimizationResult.distanceMatrix.spots[previusOperation.spot.name.toString()][
              nextOperation.spot.name.toString()
            ];
          let distanceMatrixBA =
            this.optimizationResult.distanceMatrix.spots[nextOperation.spot.name.toString()][
              previusOperation.spot.name.toString()
            ];
          //Si el driving corresponde a la operacion de bodega al destino, se usa el depotStart
          if (distanceMatrixAB) {
            operation.operationTime = distanceMatrixAB[time];
            operation.distance = distanceMatrixAB[distance];
          } else if (distanceMatrixBA) {
            operation.operationTime = distanceMatrixBA[time];
            operation.distance = distanceMatrixBA[distance];
          } else {
            /*console.log('No tengo el dato, entro aqui', distanceMatrixAB, distanceMatrixBA);
            console.log('siguiente operacion ', nextOperation);
            console.log('operacion previa ', previusOperation);*/
            //Si no encuentra el distance matrix seteo los datos como 0
            operation.operationTime = 0;
            operation.distance = 0;
          }
          operation.scheduled = previusOperation.scheduled + previusOperation.operationTime * 1000;
          operation.spot = nextOperation.spot;
          //Se suman valores para datos totales de la ruta
          chooseRoute.totalDistance += operation.distance;
          chooseRoute.totalTime += operation.operationTime;
        } else if (operation.task == 'DELIVERY' || operation.task == 'COLLECTION') {
          //Se suman valores para datos totales de la ruta
          operation.operationTime ? (chooseRoute.totalTime += operation.operationTime) : (chooseRoute.totalTime += 0);
          operation.weight ? (chooseRoute.totalWeight += operation.weight) : (chooseRoute.totalWeight += 0);
          operation.money ? (chooseRoute.totalMoney += operation.money) : (chooseRoute.totalMoney += 0);
          operation.volume ? (chooseRoute.totalVolume += operation.volume) : (chooseRoute.totalVolume += 0);
          let previusOperation = chooseRoute.operations[index - 1];
          let scheduled = previusOperation.scheduled + previusOperation.operationTime * 1000;
          //Si es que la operación no posee spotTimeWindow, se utilizara la ventana horaria del spot
          if (!operation.spotTimeWindow) {
            let spotOperation = this.optimizationBody.spots.find((spot) => spot.name == operation.spot.extraInfo.id);
            //Si el tiempo planificado se encuentra dentro de la ventana horaria del spot se utiliza ese,
            //sino se deja el inicio de la ventana horaria del spot
            if (scheduled >= spotOperation.timeWindow.startTime && scheduled <= spotOperation.timeWindow.endTime) {
              operation.scheduled = scheduled;
            } else if (scheduled < spotOperation.timeWindow.startTime) {
              operation.scheduled = spotOperation.timeWindow.startTime;
            } else {
              //Este booleano indica que no hara gatillara mensajes de alerta
              if (noValidate) {
                operation.scheduled = scheduled;
              } else {
                //Esta condicion pasa si al recalcular la hora de inicio de la operación supera a la ventana horaria indicada
                isValid = false;
                this.selectedIndex = indexRoute;
                this.operationsWithConflicts.push(operation.name);
                operation.scheduled = scheduled;
                this.showModal('confirmation-modal');
              }
            }
          } else {
            //Se usa el spotTimeWindow indicado en la operacion, y no el que posee el spot
            if (scheduled >= operation.spotTimeWindow.startTime && scheduled <= operation.spotTimeWindow.endTime) {
              operation.scheduled = scheduled;
            } else if (scheduled < operation.spotTimeWindow.startTime) {
              operation.scheduled = operation.spotTimeWindow.startTime;
            } else {
              //Este booleano indica que no hara gatillara mensajes de alerta
              if (noValidate) {
                operation.scheduled = scheduled;
              } else {
                //Esta condicion pasa si al recalcular la hora de inicio de la operación supera a la ventana horaria indicada
                isValid = false;
                this.selectedIndex = indexRoute;
                this.operationsWithConflicts.push(operation.name);
                operation.scheduled = scheduled;
                this.showModal('confirmation-modal');
              }
            }
          }
        } else if (operation.task == 'UNLOAD' || operation.task == 'END') {
          let previusOperation = chooseRoute.operations[index - 1];
          operation.spot = previusOperation.spot;
          operation.scheduled = previusOperation.scheduled + previusOperation.operationTime * 1000;
        } else {
          console.log('ESTA OPERACION QUEDO FUERA DEL ANALISIS ', operation);
          this.logService.sendInfo({
            component: 'planificationBUilder',
            message: `recalculateOperations encontro un caso que no esta manejado para el recalculo`,
            data: operation,
          });
        }

        //console.log("index: ",index,"TASK: ",operation.task," programado: ",operation.scheduled," operationTime: ",operation.operationTime);
      });
      if (isValid && !massUpdate) {
        await this.reprocesView(indexRoute);
      }
    },
    async spliceDeletedOperation(actualOperationId, chooseRoute, previusOperationId, loadOperation, depotStart) {
      //Saca la operacion eliminada del array de operations, y lo manda al de unreacheableOperations
      if (actualOperationId != null) {
        let operationDeleted = chooseRoute.operations[actualOperationId];
        let body = {
          uuid: operationDeleted.uuid,
          name: operationDeleted.name,
          resourceId: 0,
          idSpotTemporal: operationDeleted.spot.extraInfo.id,
          spotServiceTime: operationDeleted.operationTime,
          spot: operationDeleted.spot.extraInfo.id,
          depot: depotStart.spot.extraInfo.id,
          extraInfo: {
            idSolver: operationDeleted.extraInfo.idSolver,
            customerName: operationDeleted.extraInfo.customerName,
            customerPhone: operationDeleted.extraInfo.customerPhone,
            customerEmail: operationDeleted.extraInfo.customerEmail,
            additionalInfo: operationDeleted.additionalInfo ? operationDeleted.additionalInfo : null,
            sender: operationDeleted.extraInfo.idSender,
            documents: operationDeleted.extraInfo.documents,
          },
        };
        if (operationDeleted.spotTimeWindow && operationDeleted.spotTimeWindow.startTime) {
          body = {
            ...body,
            spotTimeWindow: {
              startTime: operationDeleted.spotTimeWindow.startTime * 1000,
              endTime: operationDeleted.spotTimeWindow.endTime * 1000,
            },
          };
        }
        this.optimizationResult.unreachableOperations.push(body);
        chooseRoute.operations.splice(actualOperationId, 1);
        let indice = loadOperation.deliveries.indexOf(operationDeleted.uuid);
        if (indice != -1) {
          loadOperation.deliveries.splice(indice, 1);
        }
      }
      if (previusOperationId != null) {
        chooseRoute.operations.splice(previusOperationId, 1);
      }
    },
    onSelectRoute() {
      if (this.routeSelected) {
        this.driverSelected = this.routeSelected.driver;
        this.vehicleSelected = this.routeSelected.vehicle;
      }
    },
    openEditModeOptimization() {
      this.optimizationResultEditMode = [];
      if (this.unreachableOperations.length > 0) {
        this.unreachableOperations.forEach((op) => {
          let spotSelected = this.optimizationBody.spots.find((spot) => op.spot == spot.name.toString());
          op.address = spotSelected.extraInfo.address;
          //El json de las unreacheable tiene unicamente el nombre del spot (id)
          op.spot = spotSelected.name;
        });
        this.optimizationResultEditMode.push({
          id: 0,
          isClicked: false,
          name: 'unreachableActivity',
          operations: this.unreachableOperations,
        });
      }
      //Esto desvincula la variable optimizationResultParsed para que los cambios en optimizationResultEditMode
      //No afecten directamente a optimizationResultParsed
      const optimizationParsed = JSON.parse(JSON.stringify(this.optimizationResultParsed));
      this.optimizationResultEditMode = this.optimizationResultEditMode.concat(optimizationParsed);
      this.showModal('edit-optimization-modal');
    },
    async savePlanification() {
      console.log('this.optimizationBody');
      console.log(this.optimizationBody);
      //Valida que al intentar guardar la planificación posea rutas con operaciones
      if (this.optimizationResult.statistics.reachableOperations > 0) {
        this.isMainPageBussy = true;
        //Actualizo los valores estadisticos del solver
        let body = {
          name: this.optimizationResult.name,
          totalRoutes: this.optimizationResult.routes.length,
          totalOperations: this.operations.length,
          totalReachableOperations: this.optimizationResult.statistics.reachableOperations,
          executionDate: this.optimizationBody.startDate,
          userLastModified: this.$store.getters.loggedUser['idUser'],
          inputOptimization: JSON.stringify(this.optimizationBody),
          outputOptimization: JSON.stringify(this.optimizationResult),
          //outputOptimizationSolver: this.optimizationResult,
        };
        this.showModal('planification-ready');
        this.isPlanificationReady = this.planificationId
          ? await this.updatePlanification(body)
          : await this.insertPlanification(body);
        this.isMainPageBussy = false;
      } else {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.validaciones.emptyOperations'),
          'error',
        );
      }
    },
    //Se usa cuando se accede por el modal por eso no se abre en este metodo
    async resendSavePlanification() {
      console.log('this.optimizationBody2');
      console.log(this.optimizationBody);
      this.isMainPageBussy = true;
      let body = {
        name: this.optimizationResult.name,
        totalRoutes: this.optimizationResult.routes.length,
        totalOperations: this.operations.length,
        totalReachableOperations: this.optimizationResult.statistics.reachableOperations,
        executionDate: this.optimizationBody.startDate,
        userLastModified: this.$store.getters.loggedUser['idUser'],
        inputOptimization: JSON.stringify(this.optimizationBody),
        outputOptimization: JSON.stringify(this.optimizationResult),
      };
      this.isPlanificationReady = this.planificationId
        ? await this.updatePlanification(body)
        : await this.insertPlanification(body);

      this.isMainPageBussy = false;
    },
    async updatePlanification(body) {
      const pako = require('pako');
      const compressed = pako.gzip(JSON.stringify(body));

      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `getResponseSolver preparandome para actualizar la planificación ${this.planificationId}`,
        data: body,
      });
      try {
        let url = `${this.$store.getters.urlAPI}/planification/${this.planificationId}`;

        const file = new Blob([compressed], { type: 'application/octet-stream' });

        const formData = new FormData();
        formData.append('file', file, 'file.gz');

        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
            // 'Content-Encoding': 'gzip',
            // 'Content-Type': 'application/json; charset=utf-8',
          },
        };

        const response = await axios.patch(url, formData, config);
        return response.data.status;
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `updatePlanification actualizar la planificación fallo ${e.message}`,
        });
        console.log(e);
        return false;
      }
    },
    async insertPlanification(body) {
      console.log(body);
      const pako = require('pako');
      const compressed = pako.gzip(JSON.stringify(body));
      try {
        let url = `${this.$store.getters.urlAPI}/planification`;

        const file = new Blob([compressed], { type: 'application/octet-stream' });

        const formData = new FormData();
        formData.append('file', file, 'file.gz');

        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
            // 'Content-Encoding': 'gzip',
            // 'Content-Type': 'application/json; charset=utf-8',
          },
        };

        const response = await axios.post(url, formData, config);
        return response.data.status;
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `updatePlanification actualizar la planificación fallo ${e.message}`,
        });
        console.log(e);
        return false;
      }
    },
    newPlanification() {
      this.isRouteSection = false;
      this.closeModal('planification-ready');
      this.$router.push({ name: 'Planification' });
    },
    closePlanification() {
      this.isRouteSection = false;
      this.closeModal('planification-ready');
    },
    sendTrackView() {
      this.isRouteSection = false;
      this.closeModal('planification-ready');
      this.$router.push({ name: 'TrackingPlanification' });
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    checkComponentPresence(ref) {
      if (this.$refs[ref] && this.$refs[ref].length > 0) {
        return this.$refs[ref][0].show;
      }
    },
  },
  computed: {
    jsonData() {
      return this.$store.getters.jsonDataPlanification || {};
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
    filterOperations() {
      return this.filter
        ? this.optimizationResultEditMode
            .map((route) => {
              const subArrayFiltrado = route.operations.filter((operation) => {
                return (
                  operation.name.toUpperCase().includes(this.filter.toUpperCase()) ||
                  operation.address.toUpperCase().includes(this.filter.toUpperCase())
                );
              });
              return { ...route, operations: subArrayFiltrado };
            })
            .filter((route) => route.operations.length > 0)
        : this.optimizationResultEditMode;
    },
  },
};
